<script>
import {
    layoutComputed, clientAdminState
} from "@/state/helpers";
import Vertical from "./vertical-stripped";
import Horizontal from "./horizontal";
import LoadingWidget from '@/components/widgets/misc/loadingWidget.vue'

export default {
    components: {
        Vertical,
        Horizontal,
        LoadingWidget
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
        ...clientAdminState,
        has_core_loaded(){
            if(this.core_data == null){
                return false;
            }
            return true;
        }
    },
    methods: {},
    mounted() {
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
<div>
    <Vertical v-if="has_core_loaded && layoutType === 'vertical'" :layout="layoutType">
        <slot />
    </Vertical>

    <Horizontal v-if="has_core_loaded && layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>

    <LoadingWidget v-if="has_core_loaded == false"/>
</div>
</template>
